import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=6291d2ac"
import script from "../../controllers/notice/notice-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/notice/notice-detail.js?vue&type=script&lang=js&external"
import style0 from "./NoticeDetail.vue?vue&type=style&index=0&id=6291d2ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports